import { Route } from '@angular/router';
import { ErrorComponent } from './core/error/error.component';

export const appRoutes: Route[] = [
     {
    path: 'shipments',
    loadComponent: () =>
      import('@scio-nav/shipments').then((m) => m.ShipmentsComponent),
  },
  {
    path: 'orders',
    loadComponent: () =>
      import('@scio-nav/orders').then((m) => m.OrdersComponent),
  },
  { path: '', redirectTo: 'orders', pathMatch: 'full' },
  { path: '**', component:ErrorComponent} // wildcard
];
